export const SET_TRANSLATIONS = 'SET_TRANSLATIONS'
export const SET_SERVICE_ELEMENT_TRANSLATIONS = 'SET_SERVICE_ELEMENT_TRANSLATIONS'
export const SET_TRANSLATION = 'SET_TRANSLATION'
export const SET_SERVICE_ELEMENT_TRANSLATION = 'SET_SERVICE_ELEMENT_TRANSLATION'
export const SET_CUSTOM_MESSAGE_TRANSLATIONS = 'SET_CUSTOM_MESSAGE_TRANSLATIONS'
export const SET_CUSTOM_MESSAGE_TRANSLATION = 'SET_CUSTOM_MESSAGE_TRANSLATION'



// WEBPACK FOOTER //
// ./src/store/modules/translation/types.js